import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AnimatedBackground from '../components/AnimatedBackground';
import { fireEvent } from '../utils/funnelEvents';
import ArticleStructuredData from '../components/ArticleStructuredData';
import LawyersHeader from '../components/LawyersHeader';

import LawyersHero from './lawyers/LawyersHero';
import Workflow from './lawyers/Workflow';
import PainPoints from './lawyers/PainPoints';
import DocumentTypes from './lawyers/DocumentTypes';
import RetentionAndPrivacy from './lawyers/RetentionAndPrivacy';
import ClioIntegration from './lawyers/ClioIntegration';
import RelatedReading from './lawyers/RelatedReading';
import LawyersPricing from './lawyers/Pricing';
import LawyersFAQ from './lawyers/LawyersFAQ';
import ContactInfo from './lawyers/ContactInfo';
import ResearchInviteCard from '../components/research/ResearchInviteCard';

const PAGE_TITLE = 'AI File Organizer for Lawyers: Matter-Based Filing | Sortio';
const PAGE_DESCRIPTION =
  'Sortio is the AI file organizer for lawyers. Drop intake scans, downloaded filings, and email attachments; Sortio classifies, routes by client matter, renames, and (with Clio) uploads. Cloud, BYOK, or fully local inference; audit-logged, retention-aware. Works for solo attorneys, small firms, and multi-attorney practices.';

const LawyersPage = () => {
  useEffect(() => {
    fireEvent('team_page_view', { vertical: 'lawyers' });
  }, []);

  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESCRIPTION} />
        <meta
          name="keywords"
          content="ai file organizer for lawyers, law firm document management, Clio file organization, matter-based filing, legal document AI sorter, attorney file management, client matter folder, retention rules legal"
        />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESCRIPTION} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.getsortio.com/for-lawyers" />
        <link rel="canonical" href="https://www.getsortio.com/for-lawyers" />
      </Helmet>
      <ArticleStructuredData
        title={PAGE_TITLE}
        description={PAGE_DESCRIPTION}
        datePublished="2026-05-14T00:00:00.000Z"
        dateModified="2026-05-14T00:00:00.000Z"
        authorName="Sortio Team"
      />

      <LawyersHeader />
      <LawyersHero />

      <div className="relative">
        <AnimatedBackground variant="business" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
          <Workflow />
          <PainPoints />
          <DocumentTypes />
          <RetentionAndPrivacy />
          <ClioIntegration />
          <RelatedReading />
          <LawyersPricing />
          <LawyersFAQ />
          <ResearchInviteCard vertical="legal" />
          <ContactInfo />
        </div>
      </div>
    </>
  );
};

export default LawyersPage;
